import api from "@/services/axios.js";
import { formHeaders } from "@";
import { AddVerificationFilesRequest } from "../../types.ts";
import {
  appendIdsListOrBulkUploadSearchValues,
  appendPhotosToForm,
  appendVideosToForm,
} from "../../lib/helpers.ts";
import { preSignZipUpload } from "./pre-sign-zip-upload.ts";
import { uploadZipFileToDigitalOcean } from "./upload-zip-to-digitalocean.ts";

export const addVerificationFiles = async (
  data: AddVerificationFilesRequest,
) => {
  const form = new FormData();

  appendIdsListOrBulkUploadSearchValues({ data, form });

  // Previously-uploaded zip — skip pre-sign + DigitalOcean upload
  if (data.zipKey) {
    form.append("ZipKey", data.zipKey);
    return api.post(
      "/api/AdminVerification/upload-verification-stage-files",
      form,
    );
  }

  // No zip file: append photos/videos and upload directly
  if (!data.zipFile || data.zipFile.length === 0) {
    appendPhotosToForm({ data, form });
    appendVideosToForm({ data, form });

    return api.post(
      "/api/AdminVerification/upload-verification-stage-files",
      form,
      formHeaders,
    );
  }

  // Zip file: pre-sign, upload to DigitalOcean, then submit zipKey
  const zipFileContent = data.zipFile[0] as File;
  const zipFileName = zipFileContent?.name;
  if (!zipFileContent || !zipFileName) {
    throw new Error("Zip file is required");
  }

  const { uploadUrl, zipKey } = await preSignZipUpload({
    fileName: zipFileName,
    contentType: "application/zip",
  });

  await uploadZipFileToDigitalOcean(uploadUrl, zipFileContent);  

  form.append("ZipKey", zipKey || "");

  return api.post(
    "/api/AdminVerification/upload-verification-stage-files",
    form,
  );
};
